import {
  SitemapLayout,
  SitemapLink,
  SitemapLinkWrapper,
} from 'sly/sitemap/components/SitemapSharedComponents';
import {
  SITEMAP_INDEX_BREADCRUMB_ITEMS,
  staticPathsWithLabel,
} from 'sly/sitemap/constants';

export const getServerSideProps = () => ({ props: {} });

const SitemapIndex = () => {
  return (
    <SitemapLayout
      breadcrumbItems={SITEMAP_INDEX_BREADCRUMB_ITEMS}
      metaDescription='Seniorly Sitemap'
    >
      <SitemapLinkWrapper className='mt-12'>
        {staticPathsWithLabel.map(({ label, path }) => {
          return (
            <SitemapLink key={label} href={path}>
              {label}
            </SitemapLink>
          );
        })}
      </SitemapLinkWrapper>
    </SitemapLayout>
  );
};

export default SitemapIndex;
